export default "__VITE_ASSET__B1NCvt_B__$_?url__"